import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { Badge, Stack, Text } from "@towersystems/roam-common-native";
import { StockOrder } from "@towersystems/roam-common/lib/generated-types";
import { formatDateToCalendar } from "@towersystems/roam-common/lib/shared-utils";
import { Pressable } from "react-native";
import { Colors, Spacings, View } from "react-native-ui-lib";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface StockOrderResourceListItemProps {
  item: StockOrder;
}

export const StockOrderResourceListItem = ({
  item,
}: StockOrderResourceListItemProps) => {
  const { t } = useTranslation("stockorder");
  const navigation = useNavigation<any["navigation"]>();

  return (
    <Pressable
      onPress={() => {
        if (item.status === "PENDING") {
          navigation.navigate("EditStockOrderRootScreen", {
            stockOrderId: item.id,
          });
        } else {
          navigation.navigate("ViewStockOrderRootScreen", {
            screen: "ViewStockOrderScreen",
            stockOrderId: item.id,
          });
        }
      }}
    >
      <View flex row style={{ justifyContent: "space-between" }}>
        <View>
          <View centerV flex row>
            <Text variant="heading" fontWeight="medium">
              {t("formatted_order_number", {
                order_number: item.formattedOrderNumber,
              })}
            </Text>
            <Badge
              style={{ marginLeft: Spacings.s4 }}
              stockOrderStatus={item.status as any}
            ></Badge>
          </View>
          <Text color="subdued" style={{ display: "flex" }}>
            <Text style={{ minWidth: 50, display: "flex" }}>To:</Text>
            <Text style={{ display: "flex" }} fontWeight="bold">
              {`${item.location?.name ?? t("common:unknown")}`}
            </Text>
          </Text>
          {item.orderCreatedDate ? (
            <Text color="subdued">
              {t("common:created_at", {
                date_time: formatDateToCalendar(item.orderCreatedDate),
              })}
            </Text>
          ) : undefined}
        </View>
        <View style={{ alignContent: "center", justifyContent: "center" }}>
          <Stack spacing={Spacings.s1}>
            <View style={{ alignItems: "flex-end" }}>
              <Text color="subdued" textAlign="right">
                {t("common:total_items", {
                  total: item.totalQuantity,
                })}
              </Text>
            </View>
            <View style={{ alignContent: "center", justifyContent: "center" }}>
              <Text fontWeight="bold" variant="heading1">
                <AntDesign
                  style={{ marginLeft: Spacings.s4, color: Colors.Text }}
                  name="right"
                  size={24}
                />
              </Text>
            </View>
          </Stack>
        </View>
      </View>
    </Pressable>
  );
};
